import { push } from 'connected-react-router'

import axios from 'axios'
import { handleNetworkError } from 'actions/Error'

export function fetchCampaign() {
    return (dispatch, getState) => {
        const region = getState().region.slug
        dispatch({ type: 'FETCH_CAMPAIGN' })
        axios
            .get(`${process.env.API_URL}/${region}/api/campaign`)
            .then((response) => {
                dispatch({ type: 'FETCH_CAMPAIGN_SUCCESS', payload: response.data })
            })
            .catch((err) => dispatch(handleNetworkError(err)))
    }
}

export function goToCampaign(campaign) {
    return (dispatch) => {
        dispatch({ type: 'SELECT_PROMOTION', payload: { campaign } })
        dispatch(push(`/campaign/${campaign.slug}`))
    }
}
